<template>
  <div class="flex w-full h-screen items-start justify-center bg-cover bg-position-[90%_70%] relative"
    :style="{
      backgroundImage: `url(${HeroBgImg})`,
      backgroundColor: '#f3f4f6' // fallback color while image loads
    }">
    <!-- Loading overlay for better UX -->
    <div v-if="!imageLoaded" class="absolute inset-0 bg-neutral-200 animate-pulse flex items-center justify-center">
      <div class="text-neutral-500 text-lg">Loading...</div>
    </div>

    <div class="container absolute bg-neutral-300/70 p-4" :style="{'top': `${titlePosition}%`}">
      <h1 class="text-4xl lg:text-4xl xl:text-5xl font-bold font-serif text-white text-shadow-sm/40 text-shadow-black text-center">
        {{ title }}
      </h1>
    </div>
  </div>
</template>

<script setup lang="ts">
// import HeroBgImg from '~/assets/images/hero_bg-a1.webp'
import HeroBgImg from '~/assets/images/hero_bg-a1.jpg'
// import HeroBgImg from '~/assets/images/hero_bg-a1p.jpeg'
// import HeroBgImg2 from '~/assets/images/hero_bg-a2.webp'
// import HeroBgImg3 from '~/assets/images/hero_bg-a3.webp'
import { useCriticalResources } from '~/composables/useCriticalResources'

const title = ref('Sri Chinmoy\'s Music for Inner Peace')
// const subtitle = ref('A musical journey that blends devotion of the soul with the lightness of spirit, guiding listeners inward - towards peace and inner silence.')

const titlePosition = ref<number>(50)

// Use critical resources composable for better resource management
const { isImageLoaded, preloadCriticalImage } = useCriticalResources()
const imageLoaded = computed(() => isImageLoaded(HeroBgImg))


function getTitlePosition(): number {
  if (window.innerHeight == 0) return 0
  const ratio = window.innerWidth / window.innerHeight
  console.log('Viewport ratio:', ratio)
  if (ratio < 0.7) return 10
  return 83
}

function onResize() {
  titlePosition.value = getTitlePosition()
  console.log('position:', titlePosition.value)
}

onMounted(async () => {
  onResize()
  window.addEventListener('resize', onResize)
  window.addEventListener('orientationchange', onResize)

  // Preload the background image with high priority
  try {
    await preloadCriticalImage(HeroBgImg, 'high')
  } catch (error) {
    console.warn('Failed to preload hero background image:', error)
  }
})

onUnmounted(() => {
  window.removeEventListener('resize', onResize)
  window.removeEventListener('orientationchange', onResize)
})
</script>